var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"modal test",class:_vm.customClass,attrs:{"width":_vm.size,"top":_vm.top,"show-close":false,"visible":_vm.isOpen},on:{"update:visible":function($event){_vm.isOpen=$event},"closed":_vm.close}},[(_vm.component)?[_c(_vm.component,{tag:"component",attrs:{"meta":_vm.meta}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }